<template>
  <div
    class="content-part"
    :style="
      extraItem.extras('activityTheme.display') == 1 ||
      extraItem.extras('activityTime.display') == 1 ||
      extraItem.extras('activityPlace.display') == 1 ||
      extraItem.extras('activitySchedule.display') == 1 ||
      platform == 'wap'
        ? ''
        : 'width:80%'
    "
  >
    <!-- <div class="content-part-center"> -->
    <div
      class="u-success"
      :style="{
        display:
          extraItem.extras('signSuccessTitle.display') == 0 ? 'none' : 'block',
        color: extraItem.extras('signSuccessTitle.color'),
        fontSize: pxOrVw(extraItem.extras('signSuccessTitle.size')),
        fontWeight:
          extraItem.extras('signSuccessTitle.weight') == 'default'
            ? '500'
            : extraItem.extras('signSuccessTitle.weight'),
      }"
    >
      {{ extras | extra("signSuccessTitle.model") }}
    </div>
    <div
      class="t-success"
      :style="{
        display:
          extraItem.extras('signDisplayImg.display', 0) == 0 ? 'block' : 'none',
        border:
          extraItem.extras('qrcodeborderdisplay.display', 1) == 1
            ? '1px solid #e9e9e9'
            : '0px',
      }"
    >
      <div
        class="code-tip"
        v-if="extraItem.extras('qrcodedisplay.display', 1) == 1"
      >
        参会凭证
      </div>
      <div class="code-qrcode" id="signUpQrCode"></div>
      <div class="code-person">参会人ID：{{ contactId }}</div>
    </div>
    <div
      class="t-success"
      :style="{
        display:
          extraItem.extras('signDisplayImg.display', 0) != 0 ? 'block' : 'none',
        border:
          extraItem.extras('qrcodeborderdisplay.display', 1) == 1
            ? '1px solid #e9e9e9'
            : '0px',
      }"
    >
      <!-- <div class="code-tip">参会凭证</div> -->

      <div class="code-qrcode" id="signUpQrCode">
        <img
          :src="extraItem.extras('signDisplayImg.src')"
          style="display: block"
        />
      </div>
      <!-- <div class="code-person">参会人ID：{{ contactId }}</div> -->
    </div>
    <div
      class="t-success-desc"
      :style="{
        display:
          extraItem.extras('signSuccessText.display') == 0 ? 'none' : 'block',
        color: extraItem.extras('signSuccessText.color'),
        fontSize: pxOrVw(extraItem.extras('signSuccessText.size')),
        fontWeight:
          extraItem.extras('signSuccessText.weight') == 'default'
            ? '500'
            : extraItem.extras('signSuccessText.weight'),
      }"
    >
      {{ extras | extra("signSuccessText.model") }}
      <!-- </div> -->
    </div>
    <div
      class="u-post"
      v-if="platform == 'pc' && extraItem.extras('successButton.display') == 1"
    >
      <a-button
        class="submit"
        type="primary"
        @click="gotoUrl(extraItem.extras('successButton.link_link'))"
      >
        {{ extras | extra("successButton.link_text") }}
      </a-button>
    </div>
    <div
      class="u-post"
      v-if="
        platform == 'wap' && extraItem.extras('signSuccessPost.display') == 1
      "
    >
      <a-button
        class="submit"
        type="primary"
        :style="{
          display:
            extraItem.extras('signSuccessPost.display') == 1 ? 'block' : 'none',
        }"
        :disabled="posterInfo.poster && posterInfo.poster.status != undefined"
        @click="goInvite()"
      >
        {{ extras | extra("signSuccessPost.model") }}
      </a-button>
    </div>

    <div
      class="u-post"
      v-if="platform == 'wap' && extraItem.extras('successButton.display') == 1"
    >
      <a-button
        class="submit"
        type="primary"
        @click="gotoUrl(extraItem.extras('successButton.link_link'))"
      >
        {{ extras | extra("successButton.link_text") }}
      </a-button>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import * as sbaseData from "../common/sbase";
export default {
  name: "SuccessCon",
  props: ["platform", "posterInfo"],
  data() {
    return {
      visible: false,
      needVerify: "",
      contactId: "",
    };
  },
  mounted() {
    this.needVerify = sbaseData.needVerify;
    this.contactId = sbaseData.contactId;
    new QRCode("signUpQrCode", {
      text: sbaseData.qrCode, //任意内容
      colorDark: "#000",
      colorLight: "#fff",
    });
  },
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
  methods: {
    goInvite() {
      if (!sbaseData.isSetting) {
        this.$parent.goInvite();
      }
    },
    gotoUrl(url) {
      window.$sk.goto(url, true).subscribe((url) => {
        window.open(url);
      });
    },
  },
};
</script>
